// frontend/src/components/CookieBanner.jsx
import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fait un choix
    const consent = localStorage.getItem('farm_booking_cookie_consent');
    if (!consent) {
      // Afficher après 1 seconde
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('farm_booking_cookie_consent', 'accepted');
    localStorage.setItem('farm_booking_cookie_date', new Date().toISOString());
    setShowBanner(false);
  };

  const handleRefuse = () => {
    localStorage.setItem('farm_booking_cookie_consent', 'refused');
    localStorage.setItem('farm_booking_cookie_date', new Date().toISOString());
    setShowBanner(false);
  };

  const handleClose = () => {
    // Juste fermer sans enregistrer = considéré comme refusé
    handleRefuse();
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slideUp">
      <div className="bg-white border-t-4 border-green-600 shadow-2xl">
        <div className="max-w-6xl mx-auto p-4 md:p-6">
          <div className="flex items-start gap-4">
            {/* Icône */}
            <div className="hidden md:block">
              <Cookie className="h-10 w-10 text-green-600" />
            </div>

            {/* Contenu */}
            <div className="flex-1">
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                  <Cookie className="h-5 w-5 md:hidden text-green-600" />
                  🍪 Gestion des cookies
                </h3>
                <button
                  onClick={handleClose}
                  className="text-gray-500 hover:text-gray-700 p-1"
                  aria-label="Fermer"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              <p className="text-sm text-gray-700 mb-4">
                Farm-Booking utilise uniquement des <strong>cookies techniques essentiels</strong> pour 
                le bon fonctionnement du site (authentification). Nous n'utilisons <strong>aucun cookie 
                publicitaire ou de suivi</strong>.
              </p>

              {/* Détails optionnels */}
              {showDetails && (
                <div className="mb-4 p-3 bg-gray-50 rounded-lg text-xs text-gray-600 space-y-2">
                  <p><strong>Cookies utilisés :</strong></p>
                  <ul className="list-disc ml-5 space-y-1">
                    <li><strong>farm_booking_cookie_consent</strong> : Stocke votre choix de cookies (ce bandeau)</li>
                    <li><strong>Session React</strong> : Maintient votre connexion après scan QR code</li>
                  </ul>
                  <p className="text-xs text-gray-500 mt-2">
                    Durée : Session + 1 an pour le consentement • Aucune donnée personnelle transmise à des tiers
                  </p>
                </div>
              )}

              {/* Bouton voir détails */}
              {!showDetails && (
                <button
                  onClick={() => setShowDetails(true)}
                  className="text-xs text-green-600 hover:text-green-700 underline mb-3"
                >
                  En savoir plus
                </button>
              )}

              {/* Boutons d'action */}
              <div className="flex flex-col sm:flex-row gap-2">
                <button
                  onClick={handleAccept}
                  className="flex-1 sm:flex-none px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
                >
                  Accepter
                </button>
                <button
                  onClick={handleRefuse}
                  className="flex-1 sm:flex-none px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Refuser
                </button>
              </div>

              <p className="text-xs text-gray-500 mt-3">
                En continuant à naviguer, vous acceptez l'utilisation des cookies essentiels. 
                Consultez notre <strong>Politique RGPD</strong> pour plus d'informations.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(100%);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;